import { render, staticRenderFns } from "./global_validator.vue?vue&type=template&id=1d7c13d2&scoped=true"
import script from "./global_validator.vue?vue&type=script&lang=js"
export * from "./global_validator.vue?vue&type=script&lang=js"
import style0 from "./global_validator.vue?vue&type=style&index=0&id=1d7c13d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7c13d2",
  null
  
)

export default component.exports